import { Link } from "react-router-dom";
import "./home.scss";

export default function Home({ searchesRows, reportsRows, searches, reports }) {
  let notifications = [...searchesRows, ...reportsRows];
  function dateToNum(d) {
    // Convert date "26/06/2016" to 20160626
    d = d.split("/").reverse();
    return Number(d[2] + d[1] + d[0]);
  }
  notifications.sort((a, b) => {
    return dateToNum(a.date) - dateToNum(b.date);
  });

  return (
    <div className="home">
      <div className="numbers">
        <div className="searches">
          <p className="title">عمليات البحث</p>
          <span>{searches || "-"}</span>
        </div>
        <div className="reports">
          <p className="title">عمليات الإبلاغ</p>
          <span>{reports || "-"}</span>
        </div>
      </div>

      <div className="notifications">
        <div className="top">
          <span>.</span>
          <p className="title">آخر الإشعارات</p>
        </div>

        {notifications.length > 0 ? (
          <div className="notification__items">
            {notifications.slice(0, 2).map((item) => (
              <div
                key={item.id}
                className="item"
                onClick={() => console.log(item)}
              >
                <span>{item.date}</span>
                <p>
                  حالة جديدة : <span className="title">{item.title}</span>
                </p>
              </div>
            ))}
          </div>
        ) : (
          <p className="no-data">لا توجد إشعارات</p>
        )}
      </div>

      <div className="tables">
        <div className="table">
          <div className="top">
            <Link to="/searches">شاهد الكل</Link>
            <p className="title">آخر عمليات البحث</p>
          </div>

          {searches ? (
            <div className="table__items">
              {searchesRows.map((item) => (
                <div key={item.id} className="item">
                  <p
                    className="status"
                    style={{
                      background:
                        item.status === "في انتظار تدخل الأدمن"
                          ? "red"
                          : item.status === "تم التوصل إلى نتيجة"
                          ? "green"
                          : "lightgray",
                    }}
                  >
                    {item.status}
                  </p>

                  <div className="title-div">
                    <p className="title">{item.title}</p>
                    <span>{item.date}</span>
                  </div>

                  <img className="avatar" src={item.img} alt="avatar" />
                </div>
              ))}
            </div>
          ) : (
            <p className="no-data">لا توجد بيانات</p>
          )}
        </div>

        <div className="table">
          <div className="top">
            <Link to="/reports">شاهد الكل</Link>
            <p className="title">آخر عمليات الإبلاغ</p>
          </div>

          {reports ? (
            <div className="table__items">
              {reportsRows.map((item) => (
                <div key={item.id} className="item">
                  <p
                    className="status"
                    style={{
                      background:
                        item.status === "في انتظار تدخل الأدمن"
                          ? "red"
                          : item.status === "تم التوصل إلى نتيجة"
                          ? "green"
                          : "lightgray",
                    }}
                  >
                    {item.status}
                  </p>

                  <div className="title-div">
                    <p className="title">{item.title}</p>
                    <span>{item.date}</span>
                  </div>

                  <img className="avatar" src={item.img} alt="avatar" />
                </div>
              ))}
            </div>
          ) : (
            <p className="no-data">لا توجد بيانات</p>
          )}
        </div>
      </div>
    </div>
  );
}
